window.env = window.env || {}

export const productApiHost = (window.env as any).PRODUCT_API_HOST
export const quotaApiHost = (window.env as any).QUOTA_API_HOST
export const offerApiHost = (window.env as any).PRODUCT_API_HOST
